import { Check, X, Award } from "lucide-react";
import { Section, SectionHeading, Card } from "./service-revops-ui";
import { SectionCta } from "./service-revops-section-cta";
import { gohighlevelConfig as defaultConfig } from "./service-platform-config";
import type { PlatformConfig } from "./service-platform-config";

export function ServiceVetting({
  config = defaultConfig,
}: {
  config?: PlatformConfig;
} = {}) {
  const criteria = config.criteria;
  const vaComparison = config.vaComparison;
  return (
    <Section>
      <SectionHeading
        eyebrow={config.vettingEyebrow}
        navy={config.vettingHeadlineNavy}
        blue={config.vettingHeadlineBlue}
        sub={config.vettingSub}
      />

      {/* Scorecard */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-14">
        {criteria.map((c, i) => (
          <Card key={i} radius={22}>
            <div
              className="font-display font-black mb-3 select-none"
              style={{
                fontSize: "30px",
                lineHeight: 1,
                color: "rgba(17,143,247,0.10)",
                letterSpacing: "-0.04em",
              }}
            >
              {String(i + 1).padStart(2, "0")}
            </div>
            <h3
              className="font-display font-bold mb-2"
              style={{
                fontSize: "17px",
                color: "#071E61",
                letterSpacing: "-0.02em",
              }}
            >
              {c.label.replace(/^\d+\.\s*/, "")}
            </h3>
            <p
              className="mb-4"
              style={{ fontSize: "14px", lineHeight: 1.5, color: "#6A7D97" }}
            >
              {c.what}
            </p>
            <div
              className="flex items-start gap-2 rounded-[14px] px-3.5 py-3"
              style={{
                background: "#F0FAF4",
                border: "1px solid rgba(39,220,93,0.18)",
              }}
            >
              <Award
                className="w-4 h-4 mt-0.5 shrink-0"
                style={{ color: "#27DC5D" }}
              />
              <span
                className="font-sans font-semibold"
                style={{ fontSize: "13px", lineHeight: 1.45, color: "#0B7CF2" }}
              >
                {c.score}
              </span>
            </div>
          </Card>
        ))}
      </div>

      {/* General VA vs RevOps Architect comparison */}
      <div
        className="rounded-[24px] p-6 md:p-8"
        style={{
          background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBFF 100%)",
          border: "1px solid rgba(8,46,103,0.07)",
          boxShadow: "0 14px 40px rgba(8,46,103,0.08)",
        }}
      >
        <div
          className="grid grid-cols-[1.4fr_1fr_1fr] gap-3 md:gap-5 items-center pb-5 mb-5 border-b"
          style={{ borderColor: "rgba(8,46,103,0.08)" }}
        >
          <span
            className="font-sans font-bold uppercase"
            style={{
              fontSize: "12px",
              letterSpacing: "0.16em",
              color: "#082E67",
            }}
          >
            Capability
          </span>
          <span
            className="font-display font-extrabold text-center"
            style={{
              fontSize: "17px",
              color: "#536B89",
              letterSpacing: "-0.02em",
            }}
          >
            General VA
          </span>
          <span
            className="font-display font-extrabold text-center"
            style={{
              fontSize: "17px",
              color: "#0B7CF2",
              letterSpacing: "-0.02em",
            }}
          >
            {config.platformName} Architect
          </span>
        </div>
        <div className="space-y-4">
          {vaComparison.map((row, i) => (
            <div
              key={i}
              className="grid grid-cols-[1.4fr_1fr_1fr] gap-3 md:gap-5 items-start"
            >
              <span
                className="font-display font-bold pt-1"
                style={{
                  fontSize: "14.5px",
                  color: "#071E61",
                  letterSpacing: "-0.015em",
                }}
              >
                {row.capability}
              </span>
              <div className="flex items-start gap-2 pt-1">
                <X
                  className="w-4 h-4 mt-0.5 shrink-0"
                  style={{ color: "#E53935" }}
                />
                <span
                  style={{
                    fontSize: "13px",
                    lineHeight: 1.45,
                    color: "#6A7D97",
                  }}
                >
                  {row.va}
                </span>
              </div>
              <div className="flex items-start gap-2 pt-1">
                <Check
                  className="w-4 h-4 mt-0.5 shrink-0"
                  style={{ color: "#27DC5D" }}
                />
                <span
                  style={{
                    fontSize: "13px",
                    lineHeight: 1.45,
                    color: "#071E61",
                    fontWeight: 600,
                  }}
                >
                  {row.architect}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <SectionCta copy={config.vettingCtaCopy} label={config.vettingCtaLabel} />
    </Section>
  );
}
